import React, {useState, useEffect} from 'react';
import ContentWMax from "../../Components/PageLayout/ContentWMax";
import PageTitle from "../../Components/PageTitle/PageTitle";
import Modal from 'react-modal';
import {Spin, Input} from "antd";
import {useNavigate} from 'react-router-dom';
import TaskModal from "../../Components/Task/TaskModal";
import styles from './SuncSpravochnik.module.scss';
import api from "../../services/api";
//Скелет страницы
export default function SuncSpravochnik() {
    const [isLoad] = useState(true);
    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setResult(null);
        setError(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) return;

        setIsLoading(true);
        setError(null);

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await api.post('/api/upload_xlsx', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                // Добавляем обработку прогресса загрузки
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    console.log(`Upload progress: ${percentCompleted}%`);
                    // Можно добавить отображение прогресса в UI
                }
            });

            setResult(response.data);

        } catch (err) {
            // Обрабатываем различные типы ошибок axios
            const errorMessage = err.response?.data?.error
                || err.response?.data?.message
                || err.message
                || 'Failed to process file';

            setError(errorMessage);

            // Логируем полную ошибку для отладки
            console.error('Upload error:', err);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <ContentWMax>
            <PageTitle
                title='Доска'/>

            {isLoad ?
                <>

                    <div className={styles.container}>
                        <div className={styles.card}>
                            <h2 className={styles.title}>XLSX File Parser</h2>

                            <form onSubmit={handleSubmit} className={styles.form}>
                                <div className={styles.formGroup}>
                                    <label htmlFor="file" className={styles.label}>
                                        Select XLSX file to upload:
                                    </label>
                                    <input
                                        type="file"
                                        id="file"
                                        className={styles.fileInput}
                                        accept=".xlsx"
                                        onChange={handleFileChange}
                                        disabled={isLoading}
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className={styles.submitButton}
                                    disabled={isLoading || !file}
                                >
                                    {isLoading ? (
                                        <>
                                            <span className={styles.spinner}></span>
                                            Processing...
                                        </>
                                    ) : 'Upload and Parse'}
                                </button>
                            </form>

                            {error && (
                                <div className={styles.errorAlert}>
                                    {error}
                                </div>
                            )}
                        </div>

                        {result && (
                            <div className={styles.resultsContainer}>
                                <div className={styles.resultsHeader}>
                                    <h3>Parsed Data from: {result.fileName}</h3>
                                    <span className={styles.resultsCount}>
                            {result.data.length} rows
                        </span>
                                </div>

                                <div className={styles.tableWrapper}>
                                    <table className={styles.resultsTable}>
                                        <thead>
                                        <tr>
                                            {result.data[0]?.map((_, index) => (
                                                <th key={index}>Column {index + 1}</th>
                                            ))}
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {result.data.map((row, rowIndex) => (
                                            <tr key={rowIndex}>
                                                {row.map((cell, cellIndex) => (
                                                    <td key={cellIndex} title={String(cell)}>
                                                        {String(cell)}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    </div>
                </>
                :
                <>
                    <Spin size="small"/> <span className='ml-s'>Загрузка данных...</span>
                </>
            }
        </ContentWMax>
    )
}